<template>
    <div
        class="bg-won-green-light flex items-center justify-center rounded-full text-[100%]"
        :style="`width: ${diameterPx}px; height: ${diameterPx}px;`"
    >
        <span class="text-[1em] text-won-lime uppercase">
            {{ firstLetter }}
        </span>
    </div>
</template>

<script setup>
import { computed, toRefs } from "vue";

const props = defineProps({
    userName: {
        type: String,
    },
    diameterPx: {
        type: Number,
        default: 24
    }
})

const { userName } = toRefs(props)

const firstLetter = computed(() => {
    return userName.value?.charAt(0) || '?'
})
</script>
